export default __webpack_public_path__ + "static/linear-theme-37dcc7fc622150b4a531592fabb98bb8.svg";